// @ts-nocheck

import React from 'react';
import styled, { css } from 'styled-components';

import { Target } from '../../client';
import theme from '../../styled-components/dark';
import { withOpacity } from '../../styled-components/dark/helpers';
import Link from '../Link';
const PADDING_SIZE = 1;
const DEFAULT_PADDING = 0.5;

const Wrapper = styled(Link)`
  position: relative;
  width: 100%;
  min-height: 2em;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  transition: none 150ms ease-in-out;
  transition-property: background-position, box-shadow;
  background-image: ${({ $odd }) =>
    $odd ? theme.CommonListItem.odd.backgroundColor : theme.CommonListItem.even.backgroundColor};
  color: ${theme.CommonListItem.textColor.default};
  background-size: 310% 100%;
  background-position: 100% 0%;
  box-shadow: inset 0em 0em 0em 0em transparent;
  border-top: 1px solid ${withOpacity(theme.BasketCombinationsSelectorLine.separatorBackgroundColor, '8a')};
  cursor: pointer;
  padding: ${DEFAULT_PADDING}em;
  letter-spacing: 1px;

  &:first-child {
    border-top: none;
  }

  ${!Target.__MOBILE__
    ? css`
        &:hover {
          color: ${theme.CommonListItem.textColor.default};
        }
      `
    : undefined}

  ${({ $isActive, $isCentered, $isDisabled, $depth = 0, $odd, $isHighlighted, $isInvalid }) => {
    let bgColor = undefined;

    if ($depth) {
      bgColor = $odd ? theme.ListItem.Row.expandedRowOddBackgroundColor : theme.ListItem.Row.expandedRowBackgroundColor;
    }

    return css`
      background-image: ${bgColor ? bgColor : undefined};
      background-position: ${$isActive ? '0% 0%' : undefined};
      justify-content: ${$isCentered ? 'center' : undefined};
      opacity: ${$isDisabled ? 0.5 : undefined};
      padding-left: ${$depth ? `${$depth * PADDING_SIZE + DEFAULT_PADDING}em` : undefined};
      pointer-events: ${$isDisabled ? 'none' : undefined};
      text-decoration: ${$isInvalid ? 'line-through' : 'none'};

      ${!Target.__MOBILE__
        ? css`
            &:hover {
              background-color: rgb(41, 46, 61);
              box-shadow: inset 0em 0px 1.5em -0.8em black;
              background-position: 0% 0%;

              & > .see-all-btn {
                transform: rotate(90deg) translateY(-25%);
              }
            }

            ${$isHighlighted
              ? css`
                  box-shadow: inset 0em 0px 1em 0em black;
                  &:hover {
                    box-shadow: inset 0em 0px 1em 0em black;
                  }
                `
              : undefined}
          `
        : undefined};
    `;
  }}
`;

export const ListWrapper = styled.div`
  background-color: ${theme.List.backgroundColor};
  overflow: hidden;
  ${({ $border, $marginTop }) => css`
    border-radius: ${$border ? '0.8em' : undefined};
    margin-top: ${$marginTop ? '2em' : undefined};
  `}
`;

type ListItemProps = {
  as?: string;
  children?: React.ReactNode;
  onClick?: (e: React.MouseEvent) => void;
  to?: string;
  odd?: boolean;
  isHighlighted?: boolean;
  backgroundColor?: string;
  depth?: number;
  isActive?: boolean;
  className?: string;
  isDisabled?: boolean;
  isInvalid?: boolean;
  isCentered?: boolean;
};

const ListItem = ({
  as,
  backgroundColor,
  children,
  className,
  depth = 0,
  isActive = false,
  isCentered = false,
  isDisabled = false,
  isHighlighted = false,
  isInvalid = false,
  odd = true,
  to,
  onClick,
}: ListItemProps) => {
  return (
    <Wrapper
      as={as}
      className={className}
      to={to}
      onClick={onClick}
      $isDisabled={isDisabled}
      $isHighlighted={isHighlighted}
      $odd={odd}
      $backgroundColor={backgroundColor}
      $depth={depth}
      $isActive={isActive}
      $isInvalid={isInvalid}
      $isCentered={isCentered}
    >
      {children}
    </Wrapper>
  );
};

export default ListItem;
